enum Paths {
  LoginPage = '/login',
  DashboardPage = '/',
  FindProfilePage = '/find-profile',
  CvVideoRecordPage = '/cv-video-record',
  ChoosePhotosPage = '/choose-photos',
  TakePhoto = '/take-photo',
  SpacePage = '/space',
  LogoutPage = '/logout',
}

export default Paths;
